import { useEffect, useState } from "react";

const links = [
  ["Prices", "#packages"],
  ["Why Us", "#why-us"],
  ["Cameron", "#instructors"],
  ["Our Promise", "#reviews"],
  ["Review Us", "#leave-review"],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1600px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 font-cabinet font-black text-lg tracking-tighter uppercase text-[#f5f5f0]">
          <span className="w-8 h-8 bg-[#F5B301] text-[#0a0a0a] flex items-center justify-center text-xl font-black">R</span>
          Real Life Learners
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-bold uppercase tracking-wide relative group text-[#f5f5f0]"
            >
              {label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#F5B301] transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>
        <a
          href="#book"
          data-testid="nav-book-btn"
          className="bg-[#F5B301] text-[#0a0a0a] text-sm font-bold uppercase tracking-wide px-6 py-3 hover:bg-[#f5f5f0] transition-colors duration-300"
        >
          Book a Lesson
        </a>
      </nav>
    </header>
  );
}
